const type = 'advanced'
const path = '/advance/react-node/advanced-integration/src/'
const name = 'App.js'

export { type, path, name }
